import React, { useState, useEffect } from 'react';
import { getBotTrades } from '../../api/gridApi';
import './TradeHistory.css';

const TradeHistory = ({ symbol, userId }) => {
  const [trades, setTrades] = useState([]);
  const [loading, setLoading] = useState(true);

  const baseAsset = symbol ? symbol.replace('USDT', '') : '';

  const fetchTrades = async () => {
    if (!symbol || !userId) return;
    
    const result = await getBotTrades(symbol, userId);
    
    if (result && result.success) {
      // Limit to 15 most recent trades
      setTrades(result.data.slice(0, 15));
    }
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    fetchTrades();
    const interval = setInterval(fetchTrades, 30000);
    return () => clearInterval(interval);
  }, [symbol, userId]);
 
  if (loading && trades.length === 0) {
    return (
      <div className="trade-history-compact">
        <div className="trade-header">
          <h3 className="trade-title">📈 Trade History</h3>
        </div>
        <div className="trade-body">
          <div className="skeleton" style={{ height: '300px' }}></div>
        </div>
      </div>
    );
  }

  return (
    <div className="trade-history-compact">
      <div className="trade-header">
        <h3 className="trade-title">📈 Trade History</h3>
        <span className="trade-count">
          Last {trades.length}
        </span>
      </div>
      
      <div className="trade-body">
        {trades.length === 0 ? (
          <div className="no-trades">
            <p>No trades yet</p>
          </div>
        ) : (
          <div className="trade-table-container">
            <table className="trade-table">
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Type</th>
                  <th>Price</th>
                  <th>Amount</th>
                  <th>Profit</th>
                </tr>
              </thead>
              <tbody>
                {trades.map((trade) => {
                  const dateObj = new Date(trade.executionTime);
                  const time = dateObj.toLocaleTimeString('en-US', {
                    hour: '2-digit',
                    minute: '2-digit'
                  });
                  const date = dateObj.toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric'
                  });

                  return (
                    <tr key={trade._id} className="trade-row">
                      <td className="trade-time">
                        <div className="time-cell">
                          <span className="time">{time}</span>
                          <span className="date">{date}</span>
                        </div>
                      </td>
                      <td className="trade-type">
                        <span className={`type-badge ${trade.side === 'BUY' ? 'buy' : 'sell'}`}>
                          {trade.side === 'BUY' ? 'BUY' : 'SELL'}
                        </span>
                      </td>
                      <td className="trade-price">
                        ${parseFloat(trade.price).toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                      </td>
                      <td className="trade-amount">
                        {parseFloat(trade.quantity).toFixed(6)}
                      </td>
                      <td className="trade-profit">
                        {trade.cycleProfit && trade.cycleProfit > 0 ? (
                          <span className="profit-value">
                            +${parseFloat(trade.cycleProfit).toFixed(2)}
                          </span>
                        ) : (
                          <span className="no-profit">-</span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default TradeHistory;